export default {
  namespaced: true,
  state: () => ({
    /**
     * Cờ hiển thị form khảo sát người dùng
     */
    iShowSurvey: false,
  }),
  mutations: {

    /**
     * Set giá trị cho cờ bật/tắt form khảo sát
     * @param {*} state 
     * @param {*} isShow 
     */
    setIsShowSurvey: (state, isShow) => {
      state.iShowSurvey = isShow;
    },
  },
}